import { getUSCurrency } from "@/global/utils/getUSCurrency";
import { SubtotalListItem } from "./SubtotalListItem";

export function CreditSubtotals(props: {
  creditToBeApplied: number;
  amountDue: number;
  remainingCredit: number;
}) {
  const { creditToBeApplied, amountDue, remainingCredit } = props;

  return (
    <>
      {/** service fee */}
      {creditToBeApplied > 0 ? (
        <SubtotalListItem
          label={"Available Credit"}
          value={getUSCurrency(creditToBeApplied)}
        />
      ) : null}

      {/** credit */}
      {creditToBeApplied > 0 && amountDue > 0 ? (
        <SubtotalListItem
          label={"Amount Due"}
          value={getUSCurrency(amountDue)}
        />
      ) : null}

      {/** credit */}
      {remainingCredit > 0 ? (
        <SubtotalListItem
          label={"Remaining Credit"}
          value={getUSCurrency(remainingCredit)}
        />
      ) : null}
    </>
  );
}
